import React from 'react'
import { ListingCopySEOCheckButton } from '@vzmi/shp_shared_compo'
import { SEO_TRIGGER_BTN_TXT, SEO_STATUS } from '@vzmi/shp_shared_compo/constants/proposal'
import { getSEONotCompliantText } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import styles from './main.css'

const SEOCheck = ({
  status,
  copy
}) => {
  const title = `詳情SEO規範檢核結果：${getSEONotCompliantText(status, copy)}`
  const isNotCompliant = status === SEO_STATUS.NON_COMPLIANT_PENDING
  return (
    <ListingCopySEOCheckButton
      status={status}
      className={{ [styles.isNotCompliantBtn]: isNotCompliant }}
    >
      {isNotCompliant ? title : SEO_TRIGGER_BTN_TXT[status]}
    </ListingCopySEOCheckButton>
  )
}

export default SEOCheck
